import {
    Box,
    Paper,
    Typography,
    Grid,
    Button,
    Stack,
} from "@mui/material";

import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";


const backendURL =
    process.env.REACT_APP_BACKEND_URL;


const BannerLista = ({
    banners,
    loading,
    onEditar,
    onEliminar,
}) => {

    if (loading) {

        return (
            <Typography>
                Cargando banners...
            </Typography>
        );

    }


    if (!banners?.length) {

        return (

            <Paper
                elevation={0}
                sx={{
                    p: 6,
                    textAlign: "center",
                    borderRadius: "24px",
                }}
            >

                <Typography
                    sx={{
                        color: "#687083",
                    }}
                >
                    No existen banners registrados.
                </Typography>

            </Paper>

        );

    }


    return (

        <Grid
            container
            spacing={3}
        >

            {banners.map((banner) => (

                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                    key={banner.id}
                >

                    <Paper
                        elevation={0}
                        sx={{
                            overflow: "hidden",

                            borderRadius: "24px",

                            border:
                                "1px solid #e8ebf2",

                            background: "#fff",

                            transition: ".3s",

                            "&:hover": {
                                transform:
                                    "translateY(-5px)",

                                boxShadow:
                                    "0 18px 40px rgba(18,33,63,.10)",
                            },
                        }}
                    >

                        {/* IMAGEN */}

                        <Box
                            sx={{
                                height: 220,
                                overflow: "hidden",
                            }}
                        >

                            <Box
                                component="img"
                                src={`${backendURL}/${banner.imagen}`}
                                alt={
                                    banner.titulo ||
                                    "Banner"
                                }

                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />

                        </Box>


                        {/* INFORMACIÓN */}

                        <Box
                            sx={{
                                p: 3,
                            }}
                        >

                            <Typography
                                sx={{
                                    fontWeight: 800,

                                    color: "#12213F",

                                    fontSize: "1.2rem",

                                    fontFamily: "Archivo",
                                }}
                            >
                                {banner.titulo ||
                                    "Sin título"}
                            </Typography>


                            <Typography
                                sx={{
                                    mt: 1,

                                    color: "#687083",

                                    lineHeight: 1.6,

                                    display:
                                        "-webkit-box",

                                    WebkitLineClamp: 2,

                                    WebkitBoxOrient:
                                        "vertical",

                                    overflow: "hidden",
                                }}
                            >
                                {banner.descripcion ||
                                    "Sin descripción"}
                            </Typography>


                            <Typography
                                sx={{
                                    mt: 2,

                                    color: "#8b91a0",

                                    fontSize: ".85rem",
                                }}
                            >
                                Posición:{" "}
                                <strong>
                                    {banner.posicion}
                                </strong>
                            </Typography>


                            {/* BOTONES */}

                            <Stack
                                direction="row"
                                spacing={1.5}
                                sx={{
                                    mt: 3,
                                }}
                            >

                                <Button
                                    fullWidth

                                    startIcon={
                                        <EditRoundedIcon />
                                    }

                                    onClick={() =>
                                        onEditar(
                                            banner
                                        )
                                    }

                                    sx={{
                                        borderRadius:
                                            "12px",

                                        textTransform:
                                            "none",

                                        fontWeight: 700,

                                        color: "#484a75",

                                        background:
                                            "#f1f2f8",

                                        "&:hover": {
                                            background:
                                                "#e5e7f2",
                                        },
                                    }}
                                >
                                    Editar
                                </Button>


                                <Button
                                    fullWidth

                                    startIcon={
                                        <DeleteOutlineRoundedIcon />
                                    }

                                    onClick={() =>
                                        onEliminar(
                                            banner.id
                                        )
                                    }

                                    sx={{
                                        borderRadius:
                                            "12px",

                                        textTransform:
                                            "none",

                                        fontWeight: 700,

                                        color: "#c62828",

                                        background:
                                            "#fff1f1",

                                        "&:hover": {
                                            background:
                                                "#ffe1e1",
                                        },
                                    }}
                                >
                                    Eliminar
                                </Button>

                            </Stack>

                        </Box>

                    </Paper>

                </Grid>

            ))}

        </Grid>

    );
};


export default BannerLista;